// TMOS Maintenance Mode Service
// Date: November 15, 2025
// Purpose: Frontend service for maintenance mode API

import api from './api';

export interface MaintenanceMode {
  id: string;
  is_active: boolean;
  message: string;
  scheduled_start_time?: string | null;
  scheduled_end_time: string;
  created_by: string;
  created_at: string;
  updated_at: string;
}

export interface MaintenanceStatus {
  is_active: boolean;
  message?: string;
  scheduled_end_time?: string;
}

export interface EnableMaintenanceRequest {
  message: string;
  scheduled_start_time?: string;
  scheduled_end_time: string;
}

class MaintenanceModeService {
  /**
   * Get current maintenance status (public endpoint)
   */
  async getStatus(): Promise<MaintenanceStatus> {
    const response = await api.get('/maintenance/status');
    return response.data.data;
  }

  /**
   * Get maintenance status (admin endpoint - includes full details)
   */
  async getAdminStatus(): Promise<MaintenanceMode | null> {
    const response = await api.get('/maintenance/admin/status');
    return response.data.data;
  }

  /**
   * Enable maintenance mode
   */
  async enableMaintenance(data: EnableMaintenanceRequest): Promise<MaintenanceMode> {
    const response = await api.post('/maintenance/admin/enable', data);
    return response.data.data;
  }

  /**
   * Disable maintenance mode
   */
  async disableMaintenance(): Promise<void> {
    await api.post('/maintenance/admin/disable');
  }

  /**
   * Get maintenance mode history
   */
  async getHistory(limit: number = 10): Promise<MaintenanceMode[]> {
    const response = await api.get(`/maintenance/admin/history?limit=${limit}`);
    return response.data.data || [];
  }
}

export const maintenanceModeService = new MaintenanceModeService();


